import { connectedComponent } from 'utils/redux/providerWrapper';
import TenantSwitchWarning from './tenant_switch_warning';

const ConnectedTenantSwitchWarning = connectedComponent(TenantSwitchWarning);

export default ConnectedTenantSwitchWarning;
